import https from "../../axios";
import { BaseResponse } from "../../db/response";
import normalizeBaseResponse from "../../utils/responseHandler";
import errorHandler from "../../utils/errorHandler";

interface ForgotPasswordParams {
  emailOrPhone: string;
}

export const forgotPasswordApi = async (
  params: ForgotPasswordParams,
): Promise<BaseResponse> => {
  try {
    const response = await https.post("/v1/auth/forgot-password", params);

    return normalizeBaseResponse(response.data);
  } catch (error) {
    return errorHandler(error);
  }
};
